import { CONST_ROWS_PER_PAGE } from '@commons/consts';
import {
    NEW_CONTA_PAGAR_SUCCESS,
    NEW_FILTER_NEXT_PAGE_CONTA_PAGAR_PENDING,
    NEW_FILTER_NEXT_PAGE_CONTA_PAGAR_SUCCESS,
    NEW_FILTER_NEXT_PAGE_CONTA_PAGAR_FAILURE,
    FIND_CONTA_PAGAR_PENDING,
    FIND_CONTA_PAGAR_SUCCESS,
    FIND_CONTA_PAGAR_FAILURE,
    DELETE_CONTA_PAGAR_PENDING,
    DELETE_CONTA_PAGAR_SUCCESS,
    DELETE_CONTA_PAGAR_FAILURE,
    DELETE_MULTIPLE_CONTA_PAGAR_PENDING,
    DELETE_MULTIPLE_CONTA_PAGAR_SUCCESS,
    DELETE_MULTIPLE_CONTA_PAGAR_FAILURE,
    CREATE_CONTA_PAGAR_PENDING,
    CREATE_CONTA_PAGAR_SUCCESS,
    CREATE_CONTA_PAGAR_FAILURE,
    NEW_FILTER_CONTA_PAGAR_PEDING,
    NEW_FILTER_CONTA_PAGAR_SUCCESS,
    FIND_CONTA_PAGAR_PAGAMENTOS_PENDING,
    FIND_CONTA_PAGAR_PAGAMENTOS_SUCCESS,
    FIND_CONTA_PAGAR_PAGAMENTOS_FAILURE,
    CONTA_PAGAR_ESTORNAR_PAGAMENTO_PENDING,
    CONTA_PAGAR_ESTORNAR_PAGAMENTO_SUCCESS,
    CONTA_PAGAR_ESTORNAR_PAGAMENTO_FAILURE,
    CONTA_PAGAR_ESTORNAR_MULTIPLE_PAGAMENTO_PENDING,
    CONTA_PAGAR_ESTORNAR_MULTIPLE_PAGAMENTO_SUCCESS,
    CONTA_PAGAR_ESTORNAR_MULTIPLE_PAGAMENTO_FAILURE,
    GET_TOTAIS_CONTA_PAGAR_PENDING,
    GET_TOTAIS_CONTA_PAGAR_SUCCESS,
    GET_TOTAIS_CONTA_PAGAR_FAILURE,
    NEW_FILTER_CONTA_PAGAR_SUCCESS_PDF,
    NEW_FILTER_CONTA_PAGAR_FAILURE
} from './actionTypes';

const initialState = {
    list: null,
    pagamentos: null,
    loading: false,
    loadingTotais: false,
    filter: { rows: CONST_ROWS_PER_PAGE, page: 0, where: '' },
    totais: {
        totalQuitadas: 0,
        totalVencidas: 0,
        totalParaHoje: 0,
        totalAVencer: 0
    }
}

function contaPagarReducer(state = initialState, action) {

    switch (action.type) {
        case NEW_CONTA_PAGAR_SUCCESS:
            return {
                ...state,
                loading: false,
                registro: action.registro
            }
        case NEW_FILTER_NEXT_PAGE_CONTA_PAGAR_PENDING:
        case FIND_CONTA_PAGAR_PENDING:
        case DELETE_CONTA_PAGAR_PENDING:
        case DELETE_MULTIPLE_CONTA_PAGAR_PENDING:
        case CONTA_PAGAR_ESTORNAR_MULTIPLE_PAGAMENTO_PENDING:
        case CREATE_CONTA_PAGAR_PENDING:
        case NEW_FILTER_CONTA_PAGAR_PEDING:
            return {
                ...state,
                loading: true,
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case GET_TOTAIS_CONTA_PAGAR_PENDING:
            return {
                ...state,
                loadingTotais: true,
            }
        case GET_TOTAIS_CONTA_PAGAR_SUCCESS:
            return {
                ...state,
                totais: action.totais,
                loadingTotais: false
            }
        case GET_TOTAIS_CONTA_PAGAR_FAILURE:
            return {
                ...state,
                totais: {
                    totalQuitadas: 0,
                    totalVencidas: 0,
                    totalParaHoje: 0,
                    totalAVencer: 0
                },
                loadingTotais: false
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case NEW_FILTER_NEXT_PAGE_CONTA_PAGAR_SUCCESS:
            return {
                ...state,
                list: action.list,
                filter: action.filter,
                loading: false
            }
        case NEW_FILTER_CONTA_PAGAR_SUCCESS_PDF:
            return {
                ...state,
                loading: false
            }
        case NEW_FILTER_NEXT_PAGE_CONTA_PAGAR_FAILURE:
            return {
                ...state,
                list: null,
                loading: false
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case FIND_CONTA_PAGAR_SUCCESS:
            return {
                ...state,
                registro: action.registro,
                loading: false
            }
        case FIND_CONTA_PAGAR_FAILURE:
            return {
                ...state,
                registro: null,
                loading: false
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case DELETE_CONTA_PAGAR_SUCCESS:
        case DELETE_MULTIPLE_CONTA_PAGAR_SUCCESS: {
            return {
                ...state,
                loading: false
            }
        }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case NEW_FILTER_CONTA_PAGAR_SUCCESS: {
            return {
                ...state,
                list: action.list,
                filter: action.filter,
                loading: false
            }
        }
        case NEW_FILTER_CONTA_PAGAR_FAILURE: {
            return {
                ...state,
                loading: false
            }
        }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case CREATE_CONTA_PAGAR_SUCCESS:
        case CREATE_CONTA_PAGAR_FAILURE:
            return {
                ...state,
                loading: false,
                registro: action.registro
            }
        case DELETE_CONTA_PAGAR_FAILURE:
        case DELETE_MULTIPLE_CONTA_PAGAR_FAILURE:
            return {
                ...state,
                loading: false,
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case FIND_CONTA_PAGAR_PAGAMENTOS_PENDING:
            return {
                ...state,
                loadingPagamentos: true,
            }
        case FIND_CONTA_PAGAR_PAGAMENTOS_SUCCESS:
            return {
                ...state,
                pagamentos: action.pagamentos,
                loadingPagamentos: false
            }
        case FIND_CONTA_PAGAR_PAGAMENTOS_FAILURE:
            return {
                ...state,
                pagamentos: null,
                loadingPagamentos: false
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case CONTA_PAGAR_ESTORNAR_PAGAMENTO_PENDING:
            return {
                ...state,
                loadingPagamentos: true,
            }
        case CONTA_PAGAR_ESTORNAR_PAGAMENTO_SUCCESS:
            return {
                ...state,
                pagamentos: null,
                loadingPagamentos: false
            }
        case CONTA_PAGAR_ESTORNAR_PAGAMENTO_FAILURE:
            return {
                ...state,
                pagamentos: null,
                loadingPagamentos: false
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case CONTA_PAGAR_ESTORNAR_MULTIPLE_PAGAMENTO_SUCCESS:
            return {
                ...state,
                pagamentos: null,
                loadingPagamentos: false
            }
        case CONTA_PAGAR_ESTORNAR_MULTIPLE_PAGAMENTO_FAILURE:
            return {
                ...state,
                pagamentos: null,
                loadingPagamentos: false
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        default:
            return state
    }
}

export { contaPagarReducer };